import ConsignesView from "./ConsignesView";

export default function EmptyTab({ title }) {
  const testId = `cms-tab-${title.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`;

  return <ConsignesView title={title} cmsTab={title} testId={testId} />;
}